import cs from 'classnames';
import { Space, Typography } from 'antd';
import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FiPackage } from 'react-icons/fi';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { PageHeader } from '../PageHeader';
import { IBooking } from '../../interfaces/booking.interface';

const { Text } = Typography;

const Header: FC<Partial<IBooking>> = ({
    bookingNumericId,
    statusText,
    pnfReason,
}: Partial<IBooking>) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'DETAIL' });
    const { t: ts } = useTranslation('bookings', { keyPrefix: 'STATUS' });

    const navigate = useNavigate();

    return (
        <div className="booking__header">
            <Space size={8} align="center">
                <FiPackage style={{ verticalAlign: 'middle' }} size={14} />
                <Text style={{ textTransform: 'uppercase', fontSize: 12 }}>
                    {t('BOOKING')}
                </Text>
            </Space>
            <PageHeader
                style={{ padding: 0 }}
                title={`Nº ${bookingNumericId}`}
                subTitle={(
                    <Text className={cs('table-status medium', statusText)}>
                        {pnfReason ? ts(pnfReason) : ts(statusText as string)}
                    </Text>
                )}
                onBack={() => navigate(-1)}
                backIcon={(
                    <IoMdArrowRoundBack
                        size={20}
                        color="var(--color-dark)"
                        style={{ verticalAlign: 'middle' }}
                    />
                )}
            />
        </div>
    );
};

export default memo(Header);
